// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n.chat-sidebar .card-header {\n  background-color: #f9fbfd;\n}\n.blink {\n  animation: blinker 500ms linear;\n  animation-iteration-count: 4;\n}\n@keyframes blinker {\n50% {\n    opacity: 0.2;\n}\n}", ""]);
// Exports
module.exports = exports;
